module.exports = __webpack_public_path__ + "static/media/11.06cd75d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/11.jpg
// module id = 172
// module chunks = 0